export * from "/app/node_modules/next/dist/compiled/react-dom/index.js"